import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import Swiper from '../../../../node_modules/swiper/core/core.js';
import '../../../../node_modules/swiper/shared/dom.js';

const CarouselBase = (superClass) => {
    class Carousel extends superClass {
        constructor() {
            super(...arguments);
            this.rtl = false;
            this.bulletText = 'Go to slide';
            this.nextText = 'Next slide';
            this.previousText = 'Previous slide';
            this.numberOfSlots = 0;
            this.componentName = '';
        }
        buildBulletNumber(index) {
            return this.bulletText.replace('#stage-number#', (index + 1).toString());
        }
        // eslint-disable-next-line class-methods-use-this
        calcSlidesPerView(count) {
            if (count <= 3)
                return 3;
            return 4;
        }
        transformSlotsIntoSlides() {
            const slidesWrapper = this.shadowRoot.querySelector('.swiper-wrapper');
            const slotsContainer = this.shadowRoot.querySelector('slot[name="slide-container"]');
            this.numberOfSlots = slotsContainer.assignedElements().length;
            if (this.numberOfSlots <= 3)
                slidesWrapper.classList.add('flex');
            slotsContainer.assignedElements().forEach(slot => {
                slidesWrapper.append(slot);
                if (this.numberOfSlots > 3) {
                    const card = slot.querySelector('category-tile-small');
                    card === null || card === void 0 ? void 0 : card.setAttribute('slimCard', '');
                }
            });
        }
        initCarousel(configureCarouselCallback) {
            var _a;
            const swiperContainer = this.shadowRoot.querySelector('.swiper');
            const nav = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('carousel-navigation');
            const prevEl = nav === null || nav === void 0 ? void 0 : nav.shadowRoot.querySelector('.swiper-button-prev');
            const nextEl = nav === null || nav === void 0 ? void 0 : nav.shadowRoot.querySelector('.swiper-button-next');
            const pagination = this.shadowRoot.querySelector('.swiper-pagination');
            this.settings = configureCarouselCallback({ pagination, prevEl, nextEl }, this);
            return new Swiper(swiperContainer, this.settings);
        }
        renderCarousel(content) {
            // eslint-disable-next-line no-return-assign
            const updateComponentName = () => (this.componentName += '-');
            // eslint-disable-next-line no-unused-expressions
            this.componentName.length && updateComponentName();
            return x `${content}`;
        }
    }
    __decorate([
        n({ type: Boolean })
    ], Carousel.prototype, "rtl", void 0);
    __decorate([
        n({ type: String })
    ], Carousel.prototype, "bulletText", void 0);
    __decorate([
        n({ type: String })
    ], Carousel.prototype, "nextText", void 0);
    __decorate([
        n({ type: String })
    ], Carousel.prototype, "previousText", void 0);
    __decorate([
        n({ type: Number })
    ], Carousel.prototype, "numberOfSlots", void 0);
    __decorate([
        n({ type: String })
    ], Carousel.prototype, "colorschema", void 0);
    return Carousel;
};

export { CarouselBase };
